export const UPDATA_VERIFICATE_DATA = 'propertyVerificate/UPDATA_VERIFICATE_DATA';
export const UPDATA_OTHER_PARAM_DATA = 'propertyVerificate/UPDATA_OTHER_PARAM_DATA';
export const EMPTY_VERIFICATE_DATA = 'propertyVerificate/EMPTY_VERIFICATE_DATA';
export const UPDATE_SHARE = 'propertyVerificate/UPDATE_SHARE';
const initialState = {
    VerificateData: {
        districtId: '',         //行政区
        plot_id: '',            //小区名称
        plot_name: '',            //小区名称
        cert_type: '',          //权属证件类型
        cert_type_name: '',     //其他权属证件类型
        cert_no: '',            //权属证件编号
        address: '',            //房屋坐落
        is_owner: 0,            //是否权属人
        cert_owner_title: '',   //权属人姓名
        cert_owner_id_type: '', //权属人证件类型
        cert_owner_id_no: "",   //权属人证件号码
        owner_cert_img: [],      //权属人证件图片
        cert_img: [], //权属证件图片
        plotData: [],
        shareForms: [{ cert_owner_title: null, cert_owner_id_type: null, cert_owner_id_no: null, certImgs: [] }],
        isLoad1: 0,
        isLoad2: 0,
        isLoadSF0: 0,
        isLoadSF1: 0,
        isLoadSF2: 0,
        isLoadSF3: 0,
        isLoadSF4: 0,
        isLoadSF5: 0,
        isLoadSF6: 0,
        isLoadSF7: 0,
        isLoadSF8: 0,
        isLoadSF9: 0,


    },
    otherParm: {
        isSelectOther: false,
        nullArr: [],
        showSelectFirst: false,
        imgSrc: '//breaa-pic-offline-1255419371.picsh.myqcloud.com',
        errMsg: ''
    }
};

const VerificateReducer = (VerificateData = {}, action) => {
    switch (action.type) {
        case UPDATA_VERIFICATE_DATA:
            return {
                ...VerificateData,
                [action.subType]: action.data
            };
        case EMPTY_VERIFICATE_DATA:
            return {
                districtId: '',         //行政区
                plot_id: '',            //小区名称
                plot_name: '',            //小区名称
                cert_type: '',          //权属证件类型
                cert_type_name: '',     //其他权属证件类型
                cert_no: '',            //权属证件编号
                address: '',            //房屋坐落
                is_owner: 0,            //是否权属人
                cert_owner_title: '',   //权属人姓名
                cert_owner_id_type: '', //权属人证件类型
                cert_owner_id_no: "",   //权属人证件号码
                owner_cert_img: [],      //权属人证件图片
                cert_img: [], //权属证件图片
                plotData: [],
                shareForms: [{ cert_owner_title: null, cert_owner_id_type: null, cert_owner_id_no: null, certImgs: [] }],
                isLoad1: 0,
                isLoad2: 0,
                isLoadSF0: 0,
                isLoadSF1: 0,
                isLoadSF2: 0,
                isLoadSF3: 0,
                isLoadSF4: 0,
                isLoadSF5: 0,
                isLoadSF6: 0,
                isLoadSF7: 0,
                isLoadSF8: 0,
                isLoadSF9: 0,
            };
        case UPDATE_SHARE:
            return{
                ...VerificateData,
                shareForms: shareDataReducer(VerificateData.shareForms,action)
            };
        default:
            return VerificateData
    }
}

const shareDataReducer =  (shareForms=0, action)=>{
    let t=shareForms[action.k];
    t[action.subType]=action.data;
    shareForms[action .k]=t;
     return [...shareForms];
 
 }
const otherParmReducer = (otherParm = {}, action) => {
    switch (action.type) {
        case UPDATA_OTHER_PARAM_DATA:
            return {
                ...otherParm,
                [action.subType]: action.data
            };
        default:
            return otherParm
    }
}
export default (state = initialState, action) => {
    return {
        VerificateData: VerificateReducer(state.VerificateData, action),
        otherParm: otherParmReducer(state.otherParm, action),
    };
}


export const dispatch_func = {
    update_VerificateData: (data, type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_VERIFICATE_DATA,
                subType: type,
                data: data
            });
        };
    },
    update_otherParmData: (data, type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_OTHER_PARAM_DATA,
                subType: type,
                data: data
            });
        };
    },
    empty_VerificateData: () => {
        return dispatch => {
            dispatch({
                type: EMPTY_VERIFICATE_DATA
            });
        };
    },
    update_share : (data,type,k) => {
        return dispatch => {
            dispatch({
                type: UPDATE_SHARE,
                subType:type,
                data: data,
                k:k
            });
        };
    },
};


// WEBPACK FOOTER //
// ./src/modules/propertyVerificate.js